import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { login, formatApiError } from "@/auth";
import { AuthShell, Field, ErrorBox, PrimaryButton } from "@/components/AuthShell";

export const Login = ({ onAuthed }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email.trim(), password);
      onAuthed && onAuthed(u);
      nav("/", { replace: true });
    } catch (err) {
      setError(formatApiError(err, "Sign-in failed."));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell testId="login-screen" title="Sign in" subtitle="Use the email and password your company administrator set up.">
      <form onSubmit={submit} className="space-y-3">
        <Field label="Email" testId="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required autoFocus />
        <Field label="Password" testId="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
        <ErrorBox error={error} testId="login-error" />
        <PrimaryButton testId="login-submit" type="submit" disabled={busy}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </PrimaryButton>
      </form>
      <p className="mt-5 text-center text-xs text-slate-500">
        New company? <Link data-testid="go-register-link" to="/register" className="text-orange-400 hover:underline">Create your company account</Link>
      </p>
      <p className="mt-2 text-center text-xs text-slate-500">
        <Link data-testid="forgot-password-link" to="/forgot-password" className="text-slate-400 hover:text-orange-400 hover:underline">Forgot your password?</Link>
      </p>
    </AuthShell>
  );
};

export default Login;
